<template>
  <div class="container-fluid py-7">
    <div class="card">
      <base-header class="pb-6" type="">
        <div class="row align-items-center py-4">
          <div class="col-lg-6 col-7">
            <h6 class="h2 d-inline-block mb-0">Feeder</h6>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 mb-lg-4 mt-md-0" v-for="(card, index) in cards" :key="index">
            <div class="card h-100 position-relative">
              <div class="text-center card-body">
                <div class="mb-3 text-left">
                  <h5 class="text-uppercase text-dark font-weight-bold mb-2">{{ card.name }}</h5>
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <p class="mb-0 h6 text-muted">{{ card.userId }}</p>
                    <span class="badge badge-dark text-white px-2 py-1">
                      <i class="fas fa-briefcase mr-1"></i>{{ card.brokerName }}
                    </span>
                  </div>
                  <span class="d-flex justify-content-between align-items-center">
                    <span class="d-flex align-items-center">
                      <span :class="card.status === 'Active' ? 'bg-success' : 'bg-warning'"
                        class="rounded-circle mr-2 p-1 d-inline-block">
                      </span>
                      <span class="small text-dark">
                        {{ card.status }}
                      </span>
                    </span>
                    <span v-if="!card.showLoginButton" class="badge badge-success text-dark">
                      Logged In
                    </span>
                  </span>
                </div>
                <div>
                  <base-button type="danger" class="w-100 p-2" @click="handleLogin(card.userId, card.showLoginButton)">
                    <div class="row">
                      <div class="col-5 d-flex justify-content-end align-items-center pr-0">
                        <i class="fas fa-sign-in-alt text-white"></i>
                      </div>
                      <div class="col-7 d-flex justify-content-start align-items-center pl-0">
                        <span class="ml-1 text-white">Login</span>
                      </div>
                    </div>
                  </base-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </base-header>
    </div>
  </div>
</template>
<script>
import Swal from 'sweetalert2';
export default {
  name: "Feeder",
  data() {
    return {
      cards: [],
    }
  },
  mounted() {
    this.getFeederDetails();
  },
  methods: {
    formatStatus(status) {
      if (!status) return '';
      return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
    },
    getFeederDetails() {
      this.$store.dispatch("userStore/getFeederDetails", { root: true })
        .then(response => {
          const users = response.server.data;
          this.cards = users.map(user => ({
            name: `${user.firstName} ${user.lastName}`,
            userId: user.userId,
            brokerName: user.brokerName,
            status: this.formatStatus(user.status),
            showLoginButton: false
          }));
          this.cards.forEach((card, index) => {
            this.getFeederStatus(card.userId, index);
          });
        })
        .catch(error => {
          console.error("Error in getFeederDetails:", error);
        });
    },
    getFeederStatus(userId, index) {
      const data = { userId: userId };
      this.$store.dispatch("userStore/getFeederStatus", data, { root: true })
        .then(response => {
          const loginStatus = response.server.data;
          this.cards[index].showLoginButton = (loginStatus === 'NOT_LOGGED_IN');
        })
        .catch(error => {
          console.error(`Status fetch failed for ${userId}:`, error);
        });
    },
    handleLogin(userId, showLoginButton) {
      const loginUrl = `${process.env.VUE_APP_FIREFLY_REDIRECT_BASE_URL}/users/login/${userId}`;
      if (!showLoginButton) {
        Swal.fire({
          title: 'Session Already Open',
          text: "A login session is already active. If you log in again, the previous session will be closed and a new session will start.",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#6c757d',
          confirmButtonText: 'Proceed',
          cancelButtonText: 'Cancel'
        }).then((result) => {
          if (result.isConfirmed) {
            window.open(loginUrl, '_blank');
          }
        });
      } else {
        window.open(loginUrl, '_blank');
      }
    }
  }
}
</script>